var Actions;
(function (Actions) {
    Actions["INIT_MASTER_SCHEMA_LIST"] = "getInitMasterSchemaListAction";
    Actions["GET_MASTER_SCHEMA_LIST"] = "getAllMasterSchemaList";
    Actions["HANDLE_CURRENT_PAGE_CHANGE"] = "handleMasterSchemaListPageChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE_ON_SORT"] = "handleMasterSchemaListPageChangeOnSort";
    Actions["RESET_FILTERS"] = "resetMasterSchemaListFilters";
    Actions["DELETE_LIST"] = "handleMasterSchemaListDelete";
    // filter options
    Actions["HANDLE_SORT_CHANGE"] = "handleMasterSchemaListSortChange";
    Actions["GET_SCHEMA_DETAIL_ANSWERTYPE"] = "getSchemaDetailAnswerTypeAction";
    Actions["GET_SCHEMA_BY_ANSWERTYPE"] = "getSchemaByAnswerTypeAction";
    Actions["GET_SCHEMA_LIST"] = "getSchemaList";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_INIT_MASTER_SCHEMA_LIST"] = "setInitMasterSchemaList";
    Mutations["SET_MASTER_SCHEMA_LIST"] = "setMasterSchemaList";
    Mutations["SET_LOADING"] = "setMasterSchemaListLoading";
    Mutations["SET_PAGINATION_LOADING"] = "setMasterSchemaListPaginationLoading";
    Mutations["SET_PAGINATION_CURRENT_PAGE_CHANGE"] = "setMasterSchemaListCurrentPageChange";
    Mutations["SET_DISPLAYED_RECORDS"] = "setMasterSchemaListDisplayRecords";
    Mutations["SET_ORDERED_MASTER_SCHEMA_LIST"] = "setOrderedMasterSchemaList";
    Mutations["SET_FILTERED_MASTER_SCHEMA_LIST"] = "setFilteredMasterSchemaList";
    Mutations["SET_IS_FILTER"] = "setMasterSchemaListIsFilter";
    Mutations["RESET_MASTER_SCHEMA_LIST_FILTER"] = "resetMasterSchemaListFilter";
    Mutations["SET_LAST_ORDER_PROP"] = "setMasterSchemaListLastOrderProp";
    Mutations["SET_PAGINATION_TOTAL_PAGE"] = "setMasterSchemaListPaginationTotalPage";
    Mutations["SET_COMPETENCY_UNIT_BY_SCHEMA"] = "setCompetencyUnitBySchema";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
